import { useCallback, useEffect, useState } from 'react';

import { Grid, Box, Button,Typography } from '@mui/material';
import { Dialog, TextField, SelectField, DateTimePicker } from 'style-guide';
import { snackbarToggle } from "reducers/snackbarSlicer";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { REQUEST_ACTIONS, sendRequest } from 'utils/Communicator';
import { onWarehouseChange,resetManifestSlice } from 'reducers/parcel-reducers/manifestsSlicer';
import { COUNTRY_LIST } from "constants/global-constants";

export const listOfStorageSiteCode = [{ id: 'ILMMN', name: 'Maman' }, { id: 'ILOVS', name: 'Oversease' }, { id: 'ILSWS', name: 'Swissport' }];
//export const airLinePrefixes = [{ id: "114", name: "EL AL Israel" },{ id: "44", name: "Aerolineas Argentinas" }, { id: "139", name: "Aero Mexico" }, { id: "439", name: "Aigle Azur" }, { id: "657", name: "Air Baltic" }, { id: "745", name: "Air Berlin" }, { id: "580", name: "Air Bridge Cargo" }, { id: "159", name: "Air Cargo Global" }, { id: "14", name: "Air Canada" }, { id: "427", name: "Air Caraibes" }, { id: "999", name: "Air China International" }, { id: "745", name: "Air Europe" }, { id: "57", name: "Air France" }, { id: "167", name: "Air Malawi" }, { id: "643", name: "Air Malta" }, { id: "239", name: "Air Mauritius" }, { id: "86", name: "Air New Zealand" }, { id: "115", name: "Air Serbia" }, { id: "135", name: "Air Tahiti" }, { id: "649", name: "Air Transat" }, { id: "574", name: "Allied Air" }, { id: "1", name: "American Airlines" }, { id: "810", name: "Amerijet International" }, { id: "988", name: "Asiana Airlines" }, { id: "369", name: "Atlas Global" }, { id: "134", name: "Avianca - Aerovias" }, { id: "417", name: "Bringer Air Cargo" }, { id: "125", name: "British Airways" }, { id: "489", name: "Cargojet Airways" }, { id: "172", name: "Cargolux Airlines" }, { id: "700", name: "CAL" }, { id: "160", name: "Cathay Pacific Airways" }, { id: "297", name: "China Airlines" }, { id: "112", name: "China Cargo Airlines" }, { id: "781", name: "China Eastern Airlines" }, { id: "784", name: "China Southern Airlines" }, { id: "923", name: "Corsair" }, { id: "575", name: "Coyne Airways" }, { id: "77", name: "Egypt Air" }, { id: "176", name: "Emirates Sky Cargo Airways" }, { id: "71", name: "Ethiopian Airlines" }, { id: "607", name: "Etihad Airways" }, { id: "695", name: "Eva Air" }, { id: "869", name: "Express Air Cargo" }, { id: "126", name: "Garuda Indonesia" }, { id: "301", name: "Global Aviation Services" }, { id: "173", name: "Hawaiian Air Cargo" }, { id: "96", name: "Iran Air" }, { id: "131", name: "Japan Airlines" }, { id: "745", name: "JetairFly" }, { id: "589", name: "Jet Airways" }, { id: "74", name: "KLM" }, { id: "180", name: "Korean Airlines" }, { id: "229", name: "Kuwait Airways" }, { id: "45", name: "Lan Chili" }, { id: "148", name: "Libyan Airlines" }, { id: "20", name: "Lufthansa Cargo" }, { id: "232", name: "Malaysian Airline" }, { id: "129", name: "Martinair" }, { id: "429", name: "Med View Airlines" }, { id: "805", name: "Mercury Air Cargo" }, { id: "716", name: "MNG Airlines Cargo" }, { id: "519", name: "Niger Air Cargo" }, { id: "933", name: "Nippon Cargo Airlines" }, { id: "329", name: "Norwegian Cargo" }, { id: "910", name: "Oman Air" }, { id: "214", name: "Pakistan International" }, { id: "624", name: "Pegasus Airlines" }, { id: "79", name: "Philippine Airlines" }, { id: "157", name: "Qatar Airways" }, { id: "672", name: "Royal Runei Airlines" }, { id: "512", name: "Royal Jordanian" }, { id: "117", name: "Scandinavian Airlines" }, { id: "774", name: "Shanghai Airlines" }, { id: "728", name: "Sky Gates" }, { id: "501", name: "Silk Way West Airlines" }, { id: "618", name: "Singapore Airline Cargo" }, { id: "603", name: "Srilankan Airlines" }, { id: "242", name: "Stabo Air" }, { id: "49", name: "TAP Air Portugal" }, { id: "745", name: "Thomas Cook" }, { id: "756", name: "TNT Airways" }, { id: "235", name: "Turkish Airlines" }, { id: "566", name: "Ukraine International Airways" }, { id: "16", name: "United Airlines" }, { id: "406", name: "United Parcel Service" }, { id: "738", name: "Vietnam Airlines" }, { id: "377", name: "WOW Air" }, { id: "731", name: "Xiamen Airlines" }, { id: "473", name: "XL Airways" }, { id: "871", name: "Yantze River Express" }]; 
export const airLinePrefixes = [{ "id": "114", "name": "EL AL Israel" }, { "id": "044", "name": "Aerolineas Argentinas" }, { "id": "139", "name": "Aero Mexico" }, { "id": "439", "name": "Aigle Azur" }, { "id": "657", "name": "Air Baltic" }, { "id": "745", "name": "Air Berlin" }, { "id": "580", "name": "Air Bridge Cargo" }, { "id": "159", "name": "Air Cargo Global" }, { "id": "014", "name": "Air Canada" }, { "id": "427", "name": "Air Caraibes" }, { "id": "999", "name": "Air China International" }, { "id": "745", "name": "Air Europe" }, { "id": "057", "name": "Air France" }, { "id": "167", "name": "Air Malawi" }, { "id": "643", "name": "Air Malta" }, { "id": "239", "name": "Air Mauritius" }, { "id": "086", "name": "Air New Zealand" }, { "id": "115", "name": "Air Serbia" }, { "id": "135", "name": "Air Tahiti" }, { "id": "649", "name": "Air Transat" }, { "id": "574", "name": "Allied Air" }, { "id": "001", "name": "American Airlines" }, { "id": "810", "name": "Amerijet International" }, { "id": "988", "name": "Asiana Airlines" }, { "id": "369", "name": "Atlas Global" }, { "id": "134", "name": "Avianca - Aerovias" }, { "id": "417", "name": "Bringer Air Cargo" }, { "id": "125", "name": "British Airways" }, { "id": "489", "name": "Cargojet Airways" }, { "id": "172", "name": "Cargolux Airlines" }, { "id": "700", "name": "CAL" }, { "id": "160", "name": "Cathay Pacific Airways" }, { "id": "297", "name": "China Airlines" }, { "id": "112", "name": "China Cargo Airlines" }, { "id": "781", "name": "China Eastern Airlines" }, { "id": "784", "name": "China Southern Airlines" }, { "id": "923", "name": "Corsair" }, { "id": "575", "name": "Coyne Airways" }, { "id": "077", "name": "Egypt Air" }, { "id": "176", "name": "Emirates Sky Cargo Airways" }, { "id": "071", "name": "Ethiopian Airlines" }, { "id": "607", "name": "Etihad Airways" }, { "id": "695", "name": "Eva Air" }, { "id": "869", "name": "Express Air Cargo" }, { "id": "126", "name": "Garuda Indonesia" }, { "id": "301", "name": "Global Aviation Services" }, { "id": "173", "name": "Hawaiian Air Cargo" }, { "id": "096", "name": "Iran Air" }, { "id": "131", "name": "Japan Airlines" }, { "id": "745", "name": "JetairFly" }, { "id": "589", "name": "Jet Airways" }, { "id": "074", "name": "KLM" }, { "id": "180", "name": "Korean Airlines" }, { "id": "229", "name": "Kuwait Airways" }, { "id": "045", "name": "Lan Chili" }, { "id": "148", "name": "Libyan Airlines" }, { "id": "020", "name": "Lufthansa Cargo" }, { "id": "232", "name": "Malaysian Airline" }, { "id": "129", "name": "Martinair" }, { "id": "429", "name": "Med View Airlines" }, { "id": "805", "name": "Mercury Air Cargo" }, { "id": "716", "name": "MNG Airlines Cargo" }, { "id": "519", "name": "Niger Air Cargo" }, { "id": "933", "name": "Nippon Cargo Airlines" }, { "id": "329", "name": "Norwegian Cargo" }, { "id": "910", "name": "Oman Air" }, { "id": "214", "name": "Pakistan International" }, { "id": "624", "name": "Pegasus Airlines" }, { "id": "079", "name": "Philippine Airlines" }, { "id": "157", "name": "Qatar Airways" }, { "id": "672", "name": "Royal Runei Airlines" }, { "id": "512", "name": "Royal Jordanian" }, { "id": "117", "name": "Scandinavian Airlines" }, { "id": "774", "name": "Shanghai Airlines" }, { "id": "728", "name": "Sky Gates" }, { "id": "501", "name": "Silk Way West Airlines" }, { "id": "618", "name": "Singapore Airline Cargo" }, { "id": "603", "name": "Srilankan Airlines" }, { "id": "242", "name": "Stabo Air" }, { "id": "049", "name": "TAP Air Portugal" }, { "id": "745", "name": "Thomas Cook" }, { "id": "756", "name": "TNT Airways" }, { "id": "235", "name": "Turkish Airlines" }, { "id": "566", "name": "Ukraine International Airways" }, { "id": "016", "name": "United Airlines" }, { "id": "406", "name": "United Parcel Service" }, { "id": "738", "name": "Vietnam Airlines" }, { "id": "377", "name": "WOW Air" }, { "id": "731", "name": "Xiamen Airlines" }, { "id": "473", "name": "XL Airways" }, { "id": "871", "name": "Yantze River Express" }]
const ManifestDialog = ({ openDialog, setOpenDialog, inManifestList, setInManifestList, setSelectedForExport, setValidatedList, loginUser }) => {
    const dispatch = useDispatch();
    const failedCallback = useCallback(message => dispatch(snackbarToggle({ type: 'error', message })), [dispatch]);
    const [portOfLoading, setPortOfLoading] = useState([]);
    const [parcelsFromNBO, setParcelsFromNBO] = useState([]);
    const { manifestUsers, warehouse } = useSelector(state => state.manifests);
    const {selectedLocationIndex, selectedTabIndexName} = useSelector(state => state.parcelTableFilter);
    const [exchangeRate, setExchangeRate] = new useState({});
    useEffect(() => {
        sendRequest('/api/parcel/getPortOfLoadingAgent', REQUEST_ACTIONS.POST,'' , {
            successCallback: response => {
                let wid = 13;
                if (selectedLocationIndex == 1) {
                    wid = 14;
                }
                const portOfLoadingMap = response?.data?.filter(pol => pol.warehouseId == wid)?.map(pol => ({
                    id: pol.id,
                    name: pol.name,
                }));
                setPortOfLoading(portOfLoadingMap);
            },
            failedCallback,
        });


        sendRequest('/api/parcel/getExchangeRate', REQUEST_ACTIONS.POST,'' , {
            successCallback: response => {
                setExchangeRate(response);
            },
            failedCallback,
        });

        sendRequest('/api/parcel/getWareHouseById', REQUEST_ACTIONS.POST,{"wareHouseId":selectedLocationIndex ==1 ? 14 :13} , {
            successCallback: response => {
                dispatch(onWarehouseChange(response));
                 setValue(prev => ({ ...prev, countryCode: response.params.countryCode }));
            },
            failedCallback,
        });

        

        let hawbs = [];
        for (var i = 0; i < inManifestList?.length; i++) {
            hawbs.push(inManifestList[i].jobNumber);
        }
        const request = {"hawbs":"\"" + hawbs.join("\",\"") + "\""};
        sendRequest('/api/parcel/getShippingRequestListByHawbs', REQUEST_ACTIONS.POST,request , {
            successCallback: response => {
                setParcelsFromNBO(JSON.parse(response).data);
            },
            failedCallback,
        });
    
    }, []);

    const {
        subModeData,
        shippingModeData,
        countryOfOriginData,
        userILNames,
        incotermsData,
        airPolData,
        airPoaData,
        lclPolData,
        lclPoaData,
    } = useSelector(state => state.parcelPredefinedData);
  const onHandleCloseDialog = () => {
    setOpenDialog(false);
    };
    const st = new Date(new Date().getTime());
    const [value, setValue] = useState(
        {
            id: null,
            MHWB: null,
            MAWB: null,
            storageSiteCode: listOfStorageSiteCode[0].id,
            carrierPrefixId: airLinePrefixes[0].id,
            flightDateTime: st,
            arrivalDateTime: st,
            flightNumber: null,
            countryCode: null,
            portOfLoadingId: null
        }
    );
    const getSelectedPendingRows = function () {
        return inManifestList.length
        
    }

    function formatDate1(date) {
        let p = new Intl.DateTimeFormat('en', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
            timeZone: 'UTC',
            timeZoneName: "longOffset",
        }).formatToParts(date).reduce((acc, part) => {
        acc[part.type] = part.value;
        return acc;
    }, {});
        return `${p.day}/${p.month}/${p.year}`;
    }

    const getQuoatation = function (ws, fromCode, chWeight) {
        var cal = 0;

        var fromObj = COUNTRY_LIST.find(u => u.Code === fromCode);
        var fromCountry = fromObj ? fromObj.name : fromCode;
        var sendingFromctr = null;
        for (var i = 0; i < ws?.params?.priceCountries.length; i++) {
            var cc = ws?.params?.priceCountries[i];
            console.log(cc)
            console.log(cc.name)
            if (cc.name.trim() == fromCountry) {
                sendingFromctr = cc;
                break;
            }
        }
        //var sendingFromctr = { ...ws?.params?.priceCountries.find(u => u.name === fromCountry) };
        if (!sendingFromctr) {
            //sendingFromctr = ws.params?.priceUsCountries.find(u => u.name === fromCountry)

            for (var i = 0; i < ws?.params?.priceUsCountries.length; i++) {
                var cc = ws?.params?.priceUsCountries[i];
                if (cc.name.trim() == fromCountry) {
                    sendingFromctr = cc;
                    break;
                }
            }


        }

        if (sendingFromctr) {
            var sendingFromctrT = JSON.parse(JSON.stringify(sendingFromctr))
            delete sendingFromctrT["id"];
            delete sendingFromctrT["name"];
            const keys = Object.keys(sendingFromctrT);
            keys.sort(function (a, b) { return a - b });


            for (var j = 0; j < keys.length; j++) {
                if (Number(chWeight) <= Number(keys[j])) {
                    cal = sendingFromctr[keys[j]];
                    break;
                }
            }
        }


        var mul = 3.25;
        if (exchangeRate.rates) {
            mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
        }

        return cal //* mul;
    }

    const getNISConvertedValue = (nisVal, val) => {
        if (nisVal) {
            return Number(nisVal).toFixed(2);
        }
        var mul = 3.25;
        if (exchangeRate.rates) {
            mul = exchangeRate?.rates?.ILS / exchangeRate?.rates?.USD
        }
        if (!val) {
            val = 0;
        }
        return Number(val * mul).toFixed(2)
    }

    var getValidAdminId = () => {
        var adminId = selectedLocationIndex == 1 ? 22 : 23;

        if (loginUser?.authority == 'Admin' || loginUser?.location?.code === 'IL') {
            adminId = selectedLocationIndex == 1 ? 22 : 23
        } else {
            loginUser?.location?.code === 'US' ? 22 : 23;
        }
        return adminId;
    }

    const save = () => {
        try {
            var isAnyError = false;
            if (!inManifestList?.length) {
                isAnyError = true;
                dispatch(snackbarToggle({
                    type: 'error', message: 'Select Parcels for manifest.'
                }));
                return;
            }
            if (!value.MHWB) {
                isAnyError = true;
                dispatch(snackbarToggle({
                    type: 'error', message: 'Enter HAWB.'
                }));
                return;
            }
            if (value.MHWB && value.MHWB.length != 8) {
                isAnyError = true;
                dispatch(snackbarToggle({ type: 'error', message: 'HAWB should have 8 degits only.' }));
                return;
            }
            if (!value.MAWB) {
                isAnyError = true;
                dispatch(snackbarToggle({
                    type: 'error', message: 'Enter MAWB.'
                }));
                return;
            }
            if (value.MAWB && value.MAWB.length != 8) {
                isAnyError = true;
                dispatch(snackbarToggle({ type: 'error', message: 'MAWB should have 8 degits only.' }));
                return;
            }
            if (!value.flightNumber) {
                isAnyError = true;
                dispatch(snackbarToggle({
                    type: 'error', message: 'Enter Flight number.'
                }));
                return;
            }
            if (value.flightNumber && value.flightNumber.length > 3) {
                isAnyError = true;
                dispatch(snackbarToggle({
                    type: 'error', message: 'Flight number can have 3 digits only.'
                }));
                return;
            }
            setValue(prev => ({ ...prev, countryCode: warehouse.params.countryCode }));
            var manifestListItems = []
            var listShippingRequestIdsForStart = []
            var listShippingRequestReciepts = []
            var totalMasterQuantity = 0;
            var totalMasterQuantityW = 0;
            var totalShipment = 0;
            for (var i = 0; i < inManifestList.length; i++) {
                // if (inManifestList[i].shippingStatus == 3) {
                let element = parcelsFromNBO.find(parcel => parcel.hawb === inManifestList[i].jobNumber);
                totalShipment++;
                totalMasterQuantity = totalMasterQuantity + Number(element?.params?.userPaymentData?.packages);
                totalMasterQuantityW = totalMasterQuantityW + (Number(element?.params?.userPaymentData?.packages) * Number(element?.params.userPaymentData.weight));
                // }
            }
            inManifestList.forEach(function (order) {
                //if (element?.shippingStatus == 3) {
                let element = parcelsFromNBO.find(parcel => parcel.hawb === order.jobNumber);
                listShippingRequestReciepts.push({
                    name: "HWB_" + element?.hawb + ".pdf",
                    reciept: element?.params?.userData?.reciept
                })
                listShippingRequestIdsForStart.push(element?.id);
                let user = manifestUsers.find(u => u.id === element?.userId);
                if (!user) {
                    user = element?.params?.user;
                }
                var pickUp = element?.params?.userData?.destPickup;
                if (!pickUp) {
                    pickUp = element?.params?.userData?.pickupPoint
                }

                if (!element?.params?.sender && element) {
                    element.params.sender = {}
                }
                var homeDelivary_nis = element?.params?.homeDelivary_nis

                var deliveryInstructions = ""
                if (Number(element?.params?.homeDelivary_nis) != 0) {
                    if (pickUp?.Name)
                        deliveryInstructions = pickUp?.Name + ", " + pickUp?.Phone;
                }
                var getVol = function () {
                    if (!element?.params?.userPaymentData?.length || !element?.params?.userPaymentData?.width || !element?.params?.userPaymentData?.height) {
                        return ""
                    }
                    return (Number(element?.params?.userPaymentData?.length) * Number(element?.params?.userPaymentData?.width) * Number(element?.params?.userPaymentData?.height)) / 5000000;
                }
                var getChargableWt = (list) => {
                    
                    var weight = list.params?.userPaymentData.weight;
                    var h = list.params?.userPaymentData.height;
                    var w = list.params?.userPaymentData.width;
                    var l = list.params?.userPaymentData['length'];
                    var wt = Number(l) * Number(w) * Number(h) /5000;
                    var chWt = Number(wt) > Number(weight) ? Number(wt) : Number(weight);
                    return Number(chWt).toFixed(2)
                }
                
                var getChargeableWeight = function () {
                    return getChargableWt(element);
                }
                
                var ws = warehouse;
                var transportVal_nis = element?.params?.transportVal_nis;
                var cur = element?.params?.currency;
               /* if (ws?.params?.biz) {
                    var transPortVal = getQuoatation(ws, element?.params.sender.senderCountry, getChargeableWeight())
                    transportVal_nis = getNISConvertedValue(false, transPortVal);
                    //homeDelivary transportVal transportVal_nis homeDelivary_nis finalAmount finalAmount_nis
                    if (transPortVal)
                        homeDelivary_nis = getNISConvertedValue(false, 4)

                    if (!cur) {
                        cur = element?.params?.selectedCurrency?.id

                    }
                } */

                var manifestItem = {
                    Sender: element?.params.sender.senderName,
                    SenderAddress: element?.params.sender.senderAddr,
                    SenderCountry: element?.params.sender.senderCountry,
                    //ReceiverName: user?.firstName + " " + user?.lastName,
                    //ReceiverName: (order?.coClient ? order?.coClient : user?.setting?.register_company) + " " + user?.lastName + " " + user?.firstName,
                    ReceiverName: (order?.coClient ? (order?.coClient + " " + order?.coVatId) : ((user?.setting?.register_company ? (user?.setting?.register_company + " " + user?.setting?.companyId) : (user?.lastName + " " + user?.firstName + " " + user?.setting?.companyId)))),
                    ReceiverStreetAddress: pickUp?.Street ? pickUp?.Street : "" + ", " + pickUp?.House ? pickUp?.House : "",
                    ReceiverZipcode: pickUp?.ncode ? pickUp?.ncode : "",
                    ReceiverCity: pickUp?.City ? pickUp?.City : "",
                    ReceiverCountry: "IL",//user.setting.register_countryCode,
                    ReceiverPhone: user?.phone,
                    ReceiverEmail: user?.email,
                    //ReceiverReceiverId: user?.setting?.profileId,
                    ReceiverReceiverId: (order?.coVatId ? order?.coVatId : (user?.companyId ? user?.companyId : user?.setting.companyId)),
                    ConsignmentNumber: element?.hawb,
                    Reference1: element?.serialNum,
                    Reference2: "",
                    GoodsDesc: element?.shippingDesc,
                    Cubic: getVol(),
                    Weight: element?.params?.userPaymentData?.weight,
                    ChargeWeight: getChargeableWeight(),
                    Quantity: element?.params?.userPaymentData?.packages,
                    DeliveryInstructions: deliveryInstructions,//$scope.admin.data.manifest.deliveryInstructions,
                    InvoiceValue: element?.params?.invoiceOriginal ? element?.params?.invoiceOriginal : element?.params?.invoiceValue,
                    InvoiceCurrency: element?.params?.currency ? (element?.params?.currency == 1 ? 'USD' : 'EUR') : "USD",
                    InvoiceLineQty: "1",//$scope.admin.data.manifest.invoiceLineQty,CarrierPrefix
                    InvoiceLineAmount: element?.params?.invoiceOriginal ? element?.params?.invoiceOriginal : element?.params?.invoiceValue,//$scope.admin.data.manifest.invoiceLineAmount,admin.data.manifest.MHWB
                    OriginPort: value.countryCode + portOfLoading.find(u => u.id === value.portOfLoadingId)?.name || '',
                    GatewayPort: value.countryCode + portOfLoading.find(u => u.id === value.portOfLoadingId)?.name || '',
                    AgentCode: 'AGN',
                    CarrierPrefix: value?.carrierPrefixId,
                    MAWB: value?.MAWB,
                    HAWB: value?.MHWB,
                    FlightDate: formatDate1(value.flightDateTime),// value.flightDateTime.getDate() + "/" + value.flightDateTime.getMonth() + "/" + value.flightDateTime.getFullYear(),
                    FlightTime: value.flightDateTime.getUTCHours() + ":" + value.flightDateTime.getUTCMinutes(),// + ":" + value.flightDateTime.getSeconds(),
                    FlightNumber: value.flightNumber,
                    ETADate: formatDate1(value.arrivalDateTime),//value.arrivalDateTime.getDate() + "/" + value.arrivalDateTime.getMonth() + "/" + value.arrivalDateTime.getFullYear(),
                    SendeETATimer: value.arrivalDateTime.getUTCHours() + ":" + value.arrivalDateTime.getUTCMinutes(),//+ ":" + value.arrivalDateTime.getSeconds(),
                    TotalMasterQuantity: totalMasterQuantity,
                    TotalMasterWeightKgm: totalMasterQuantityW,
                    InvoiceLineOriginCountry: value.countryCode,
                    IsAutonomy: 'No',
                    CourierAWBDate: element?.date ? formatDate1(new Date(element?.date)) : '',//new Date(element?.date).getDate() + "/" + new Date(element?.date).getMonth() + "/" + new Date(element?.date).getFullYear(),
                    ReceiverPassportId: "",
                    ReceiverPassportCountry: user?.setting?.register_countryCode,
                    FreightTotalAmount: "",
                    FreightCurrency: "USD",
                    DeliveryMethod: Number(element?.params?.homeDelivary_nis) == 0 ? "C" : "A",
                    TotalPackageInMawb: element?.params?.userPaymentData?.packages,
                    TotalShipment: totalShipment,
                    CrateNumber: "",
                    StorageSiteCode: value.storageSiteCode,
                    empty1: "",
                    empty2: "",
                    "Amount to be Charge In Nis": Number(transportVal_nis ? transportVal_nis : 0) == 0 ? "" : "20:" + Number(transportVal_nis ? transportVal_nis : 0).toFixed(2),
                    "Amount to be Charge In Nis1": Number(element?.params?.vat_nis ? element?.params?.vat_nis : 0) == 0 ? "" : ("T4:" + Number(element?.params?.vat_nis ? element?.params?.vat_nis : 0)),
                    "Amount to be Charge In Nis2": Number(element?.params?.purchaseTax_nis ? element?.params?.purchaseTax_nis : 0) + Number(element?.params?.addCharges_nis ? element?.params?.addCharges_nis : 0) + Number(element?.params?.customsCharge_nis ? element?.params?.customsCharge_nis : 0) == 0 ? "" : ("T1:" + (Number(element?.params?.purchaseTax_nis ? element?.params?.purchaseTax_nis : 0) + Number(element?.params?.addCharges_nis ? element?.params?.addCharges_nis : 0) + Number(element?.params?.customsCharge_nis ? element?.params?.customsCharge_nis : 0))),
                    "Amount to be Charge In Nis3": (Number(homeDelivary_nis ? homeDelivary_nis : 0) == 0 ? "" : "23:" + Number(homeDelivary_nis ? homeDelivary_nis : 0).toFixed(2)),
                    "Amount to be Charge In Nis4": element?.params?.isInsurence ? (Number(element?.params?.insurence_nis ? element?.params?.insurence_nis : 0) == 0 ? "" : "24:" + (Number(element?.params?.insurence_nis ? element?.params?.insurence_nis : 0))) : "",
                    "Receipt Number": element?.params?.TRANZILLA_RECIEPT?.document?.number,
                    "PendingCode": "PENDING",
                }
                manifestListItems.push(manifestItem);
                //}
            })

            var objToSave = {
                opcode: "addManifestAgent",
                id: value.id,
                name: "",
                MAWB: value.MAWB,
                manifestItems: manifestListItems,
                warehouseId: warehouse.id,
                wId: warehouse.id,
                //adminId: selectedLocationIndex == 1? 22 : 23,
                adminId: getValidAdminId(),
                params: {
                    containerID: "",
                    countryOfImport: value.countryCode,
                    dropStatus: (selectedTabIndexName == 'Drops' || selectedTabIndexName == 'DropsHistory'),
                    StorageSiteCode: value.storageSiteCode,
                    AirTerminal: "",//$scope.admin.data.shippingRequest.AirTerminal.name,
                    MHWB: value.MHWB,
                    reqForStart: listShippingRequestIdsForStart,
                    recieptList: listShippingRequestReciepts,
                    value: value
                },
            }
            if (getValidAdminId() == 0) {
                isAnyError = true;
            }
            if (!isAnyError) {
                let request = {"manifestRequest":JSON.stringify(objToSave)};
                sendRequest('/api/parcel/addManifestAgent?loginUserId='+loginUser?.id, REQUEST_ACTIONS.POST,request , {
                    successCallback: response => {
                        if (response?.message == 'SUCCESS') {
                            for (var i = 0; i < inManifestList?.length; i++) {
                                sendRequest(`/api/parcel/updateManifestCloseFlag/${inManifestList[i].id}/true?fromStage=0`, REQUEST_ACTIONS.PUT, '', {
                                successCallback: data => {},
                                failedCallback,
                                });
                            }
                                dispatch(snackbarToggle({ type: 'success', message: 'Manifest saved successfully' }));
                                onHandleCloseDialog();
                                dispatch(resetManifestSlice(null));
                                setInManifestList([]);
                                setSelectedForExport([]);
                                setValidatedList([]);
                        } else {
                            dispatch(snackbarToggle({ type: 'error', message: 'Manifest not saved successfully with message:'+response?.message }));
                        }
                    },
                    failedCallback,
            });

        }
        } catch (err) {
            console.log(err)
            dispatch(snackbarToggle({ type: 'error', message: '' + err.message }));
        }

    };
  return (
    <Dialog maxWidth='md' open={openDialog} onHandleCancel={onHandleCloseDialog} title='Manifest'>
      <Box component='form' noValidate autoComplete='off'>
              <Grid container item spacing={2} >
                  <Grid container item spacing={2}>
                      <TextField
                          required
                          lg={5.5}
                          value={value.MHWB}
                          onChange={event => setValue(prev => ({ ...prev, MHWB: event.target.value }))}
                          label='HAWB'
                      //readOnly={value.id ? true : false}
                      />
                      <TextField
                          required
                          lg={5.5}
                          value={value.MAWB}
                          onChange={event => setValue(prev => ({ ...prev, MAWB: event.target.value }))}
                          label='MAWB'
                      // readOnly={value.id ? true : false}
                      />

                      <SelectField
                          required
                          value={value.storageSiteCode}
                          lg={5.5}
                          onChange={event => setValue(prev => ({ ...prev, storageSiteCode: event.target.value }))}
                          label='Storage Site Code'
                          options={listOfStorageSiteCode}
                          disabled={true}
                      />
                      <TextField
                          required
                          lg={5.5}
                          value={getSelectedPendingRows()}
                          label='HAWQTY'
                          readOnly={true}
                      />
                      <SelectField
                          required
                          value={value.carrierPrefixId}
                          lg={5.5}
                          onChange={event => setValue(prev => ({ ...prev, carrierPrefixId: event.target.value }))}
                          label='Air Line'
                          options={airLinePrefixes}
                      />
                      <DateTimePicker
                          sm={null}
                          md={null}
                          xs={5.5}
                          label={<Typography fontSize="0.8rem" fontWeight='bold'>Flight date and time (GMT)</Typography>}
                          value={value.flightDateTime}
                          onChange={date => setValue(prev => ({ ...prev, flightDateTime: date }))}
                          style={{ 'top': '15px', left: '35px' }}
                      />

                      <TextField
                          required
                          lg={5.5}
                          value={value.flightNumber}
                          onChange={event => setValue(prev => ({ ...prev, flightNumber: event.target.value }))}
                          label='Flight Number'
                      />
                      <TextField
                          required
                          lg={5.5}
                          value={value.countryCode}
                          onChange={event => setValue(prev => ({ ...prev, countryCode: event.target.value }))}
                          label='Country code'
                      />
                      <SelectField
                          required
                          value={value.portOfLoadingId}
                          lg={5.5}
                          onChange={event => setValue(prev => ({ ...prev, portOfLoadingId: event.target.value }))}
                          label='Port of loading'
                          options={portOfLoading}
                      />
                      <DateTimePicker
                          sm={null}
                          md={null}
                          xs={5.5}
                          label={<Typography fontSize="0.8rem" fontWeight='bold'>Arrival date and time (GMT)</Typography>}
                          value={value.arrivalDateTime}
                          onChange={date => setValue(prev => ({ ...prev, arrivalDateTime: date }))}
                          style={{ 'top': '15px', left: '35px' }}
                      />
                  </Grid>
                  <Grid container item justifyContent='flex-end' lg={11}>
                      <Button variant='contained' sx={{ mt: 2, mr: 2 }} onClick={save}>
                          {value.id ? 'Update' : 'Create'}
                      </Button>
                      <Button variant='contained' sx={{ mt: 2 }} color='secondary' onClick={onHandleCloseDialog}>
                          Cancel
                      </Button>
                  </Grid>

              </Grid>
      </Box>
    </Dialog>
  );
};

export default ManifestDialog;